import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MainLoginComponent} from './main-login.component/main-login.component';
import {PageNotFoundComponent} from './components/generic/not-found/not-found.component';
import {MainPortalComponent} from './main-portal.component/main.component';
import {PortalRoutesModules} from './app.portal.routes';
import {AdminRoutesModules} from './app.admin.routes';
import {MainAdminComponent} from './main-admin.component/main.component';
import {RecoverAccountComponent} from './main-recover.component/recover-account.component';
import {RegistryComponentComponent} from './main-registry.component/registry-continue.component';


const routes: Routes = [
  {
    path: 'login',
    component: MainLoginComponent,
    // canActivate: [AuthGuardLoged],
    data: {
      pageTitle: 'Login - APP.'
    }
  },
  {
    path: 'recuperar',
    component: RecoverAccountComponent,
    data: {
      pageTitle: 'Recuperar cuenta de Portal de TIAS.'
    }
  },
  {
    path: 'registro',
    component: RegistryComponentComponent,
    data: {
      pageTitle: 'Finaliza tu registro.'
    }
  },
  {
    path: 'portal',
    component: MainPortalComponent,
    children: [
      ...PortalRoutesModules
    ],
    data: {
      pageTitle: 'Portal de TIAS AIQ'
    },
  },
  {
    path: 'app',
    component: MainAdminComponent,
    data: {
      pageTitle: 'Administración de TIAS AIQ.'
    },
    children: [
      ...AdminRoutesModules
    ]
  },
  {path: '', redirectTo: '/portal', pathMatch: 'full'},
  {path: '**', component: PageNotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
